<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="fromData"
      label-position="right"
      label-width="150px"
     
    >
      <el-form-item :label="dataobjs.yonghuquanqianleixing" prop="roletype" style="width:50%"  v-if="title != '重置密码'">
        <el-select
          v-model="ruleForm.roletype"
          placeholder="请选择"
          style="width:100%"
          @change="myUserLei"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.lable"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="dataobjs.yonghuquanqianleixing1" prop="roletype1" style="width:50%"  v-if="title != '重置密码'">
        <!-- <el-input v-model="ruleForm.roletype1" style="width:100%"></el-input> -->

        <el-select v-model="ruleForm.roletype1" placeholder="请选择" style="width:100%"  v-if="title != '重置密码'">
          <el-option
            v-for="item in optionsAll"
            :key="item.value"
            :label="item.lable"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经销商"  v-if="fly" style="width:50%">
        <el-select
          v-model="ruleForm.dealer_uuid"
          placeholder="请选择"
          style="width:100%"
          @change="myFaly"
        >
          <el-option
            v-for="item in optionsJxs"
            :key="item.id"
            :label="item.dealername "
            :value="item.uuid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户" prop="name" v-if="fly1" style="width:50%">
        <el-select
          v-model="ruleForm.customer_uuid"
          placeholder="请选择"
          style="width:100%"
          @change="myFaly"
        >
          <el-option
            v-for="item in customer_uuidOption"
            :key="item.id"
            :label="item.customername"
            :value="item.uuid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名" prop="optname" style="width:50%"  v-if="title != '重置密码'">
        <el-input v-model="ruleForm.optname"></el-input>
      </el-form-item>

      <el-form-item label="密码"  style="width:50%"  v-if="title == '重置密码'">
        <el-input v-model="ruleForm.optpassword"></el-input>
      </el-form-item>
      <!-- <el-form-item label="确认密码" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="密码提示" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="手机" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="固定电话" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="短信接收人" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="系统使用者" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      <!-- </el-form-item> -->
    </el-form>
   <div class="btenEtiel">
      <span slot="footer" class="dialog-footer addcentent">
      <el-button @click="dialogVisible('ruleForm')">{{dataobjs.quxiao}}</el-button>
      <el-button type="primary" @click="resetForm('ruleForm')">{{dataobjs.queding}}</el-button>
    </span>
   </div>
  </div>
</template>
<script>
import { updatedataOut, Dealerinfo, customerlist } from "@/network/index";
import md5 from "js-md5";
export default {
  props: {
    title:{
      type:String
    },
    diohide: {
      type: Function,
      default: Function
    },
    dataobjs:{
      type:Object,
      default:{}
    },
    ruleForm: {
      type: Object,
      default() {
        return {};
      }
    },
    userList: {
      type: Function,
      default: Function
    },
  },
  data() {
    return {
      fly: false,
      lable: "",
      optionsJxs: [],
      customer_uuidOption: [],
      value: "",
      options: [
        {
          value: "0",
          lable: "总平台类账号"
        },
        {
          value: "1",
          lable: "经销商类账号"
        },
        {
          value: "2",
          lable: "客户类账号"
        }
      ],
      optionsAll: [
        {
          value: "0",
          lable: "主账号"
        },
        {
          value: "1",
          lable: "子账号"
        }
      ],
      rules: {
        optname: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        optpassword: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        roletype: [
          { required: true, message: "请选择户权限类型", trigger: "change" }
        ],
        roletype1: [
          { required: true, message: "请选择户权限类型1", trigger: "change" }
        ]
      },
      flyOne: "",
      fly1: false
    };
  },
  mounted() {
    this.Dealerinfo(1);
    this.customerlist()
  },
  methods: {
    /***
     * 下拉列表信息
     */
    myFaly(e) {
      if (this.flyOne == 1) {
        //经销商
        this.resetForm.customer_uuid = "";
        this.ruleForm.dealer_uuid = e;
      } else if (this.flyOne == 2) {
        //客户
        this.ruleForm.dealer_uuid = "";
        this.ruleForm.customer_uuid = e;
      }
    },
    /***
     * 判断是经销商还是客户
     */
    myUserLei(e) {
      if (e == 1) {
        this.fly = true;
        this.flyOne = e;
        this.fly1 = false;
        this.Dealerinfo(e);
      } else if (e == 2) {
        this.flyOne = e;
        this.fly1 = true;
        this.fly = false;
        this.Dealerinfo(e);
      } else {
        this.fly = false;
        this.fly1 = false;
      }
    },
    // 获取经销商和客户下拉列表
    async Dealerinfo(e) {
    
      
      if (e == 1) {
        const { code, data, msg } = await Dealerinfo();
        console.log(data);
        
        if (code) this.optionsJxs = data;
      } else {
       this.customerlist()
      }
    },
    async customerlist(){
       const { code, data, msg } = await customerlist();
        if (code) this.customer_uuidOption = data;
    },
    // 确定
    resetForm(formName) {
     
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let password = md5(this.ruleForm.optpassword);
          this.ruleForm.optpassword = password.toUpperCase();
          const { code, msg } = await updatedataOut(this.ruleForm);
          if (code) {
            this.$message.success(msg);
            this.fly = false;//经销商
            this.fly1 = false;//客户
            this.userList();
            this.$refs[formName].resetFields();
            this.diohide(); //关闭他弹框
          } else {
            this.$message.error(msg);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    dialogVisible(formName) {
      // console.log(formName);
      this.$refs[formName].resetFields();
      this.fly = false;
      this.fly1 = false;
      this.diohide();
    }
  }
};
</script>
<style>
.el-form-item {
  margin-bottom: 10px;
}
.addcentent {
  display: flex;
  justify-content: center;
}
.fromData {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>